export default "__VITE_ASSET__iB8ZoGw0__"